import BaseItemView from 'app/src/views/base/BaseItemView';
import paymentViewTemplate from './templates/payment-list-item.hbs';

let _Events = {
  REMOVE_BUTTON_CLICKED: 'remove:button:clicked',
};

// configure
let View = BaseItemView.extend({
  tagName: 'tr',
  template: paymentViewTemplate,

  ui: {
    removePaymentButton: 'button',
  },

  triggers: {
    'click @ui.removePaymentButton': _Events.REMOVE_BUTTON_CLICKED,
  },
});

// define
export default class PaymentListPaymentView extends View {
  /**
   * Called by Marionette before the payment is rendered.  Here, we add custom
   * data into the view data which is passed as properties on the model.
   */
  onBeforeRender() {
    if (this.model.details) {
      this.viewData = this.viewData || {};
      this.viewData.details = this.model.details;
    }

    if (this.model.depositPayment) {
      this.viewData = this.viewData || {};
      this.viewData.depositPayment = this.model.depositPayment.toJSON();
      this.viewData.depositPayment.model.cardNumber = this.model.depositPayment.model.cardNumber;
    }
  }
}
